/**
 * Frontend feature flags for paused backend features.
 *
 * Each flag defaults to `false` until the matching backend route stops
 * returning the structured `FEATURE_PAUSED` 501 stub (see
 * `services/copilot/src/clinisharp_agents/api/_paused.py`).
 *
 * Override via `.env.local` with the matching `VITE_ENABLE_*` value.
 */

const TRUE_VALUES = new Set(["1", "true", "yes", "on"]);

function readBool(value: string | undefined): boolean {
  if (!value) return false;
  return TRUE_VALUES.has(value.trim().toLowerCase());
}

export function isTtsEnabled(): boolean {
  return readBool(import.meta.env.VITE_ENABLE_TTS);
}

export function isProactiveEnabled(): boolean {
  return readBool(import.meta.env.VITE_ENABLE_PROACTIVE);
}
